import logo2022 from "../../assets/img/historicEvents/LogoDay1/2022.png";
import logo2024 from "../../assets/img/historicEvents/LogoDay1/2024.png";

export const day1Detail = {
  "day-1": {
    id: "day-1",
    title: "Day 1",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "day-1",
        items: [
          {
            id: "day-1-2022",
            title: "Day 1",
            description: "2022",
            imgUrl: logo2022,
          },
          {
            id: "day-1-2024",
            title: "RAW",
            description: "Day 1 2024",
            imgUrl: logo2024,
          },
        ],
      },
    ],
  },
};
